import React, {useEffect} from "react";

import {HashRouter, BrowserRouter, Router, Route, Switch, Redirect as RRedirect, withRouter} from "react-router-dom";
import {XkkContainer} from "../container/XkkContainer";
import {Redirect} from "../component/Redirect";
import {ConfirmContainer} from "../container/ConfirmContainer";
import {CheckstatusContainer} from "../container/CheckstatusContainer";
import {MessageContainer} from "../container/MessageContainer";
import {TimeoutContainer} from "../container/TimeoutContainer";
import {StatusContainer} from "../container/StatusContainer";
import {BankFailureContainer} from "../container/BankFailureContainer";


const ComponentNotFound = () => <RRedirect to='/'/>

export function AppRouter({history}) {

    useEffect(() => {
        console.log("this is an effect in AppRouter")
    })


    return <BrowserRouter>
        <Switch>
            <Route exact={true} path="/" component={XkkContainer}/>
            <Route path="/confirm" component={ConfirmContainer}/>
            <Route path="/checkstatus/:uuid" component={CheckstatusContainer}/>
            <Route path="/statustimeout/:uuid" component={TimeoutContainer}/>
            <Route path="/status/:uuid/:status/:voucherCode/:email" component={StatusContainer}/>
            <Route path="/redirect/:encoding" component={Redirect}/>
            <Route path="/message/:msg" component={MessageContainer}/>
            <Route path="/bankfailure" component={BankFailureContainer}/>
            <Route component={ComponentNotFound}/>
        </Switch>
    </BrowserRouter>

}


//export const AppRouter = withRouter(({history}) => <Component history={history}/>);



